import { render, staticRenderFns } from "./coupon.vue?vue&type=template&id=c25d6b40&scoped=true&"
import script from "./coupon.vue?vue&type=script&lang=ts&"
export * from "./coupon.vue?vue&type=script&lang=ts&"
import style0 from "./coupon.vue?vue&type=style&index=0&id=c25d6b40&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c25d6b40",
  null
  
)

export default component.exports